document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-media-thumb]').forEach(btn=>btn.addEventListener('click',()=>{
    const target=document.querySelector(btn.dataset.mediaTarget); if(target){target.src=btn.dataset.mediaSrc;target.alt=btn.dataset.mediaAlt||'';}
  }));
  document.querySelectorAll('[data-variant-select]').forEach(select=>{
    select.addEventListener('change',()=>{
      const opt=select.options[select.selectedIndex];
      const wrap=select.closest('[data-product-form-wrap]'); if(!wrap)return;
      const price=wrap.querySelector('[data-product-price]'); if(price&&opt.dataset.price)price.textContent=opt.dataset.price;
      const button=wrap.querySelector('[data-add-button]'); if(button){const available=opt.dataset.available==='true';button.disabled=!available;button.textContent=available?'In den Warenkorb':'Nicht verfügbar';}
    });
  });
  const toggle=document.querySelector('[data-mobile-toggle]');
  const menu=document.querySelector('[data-mobile-menu]');
  if(toggle&&menu){toggle.addEventListener('click',()=>{const open=menu.hidden===false;menu.hidden=open;toggle.setAttribute('aria-expanded',String(!open));});}
});